import { queryClient } from '../queryClient';

import { createLogoQueryOptions } from './queryOptions';

export type PrefetchLogoQuery = {
  collectionId: number;
  kSql?: string;
  referenceId: string;
};

export async function prefetchLogoQuery({ collectionId, kSql, referenceId }: PrefetchLogoQuery) {
  return queryClient.prefetchQuery(createLogoQueryOptions({ collectionId, kSql, referenceId }));
}
